'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\t', ';\n\ttext-align: left;\n'], ['\n\t', ';\n\ttext-align: left;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\tmargin-right: 50px;\n'], ['\n\tmargin-right: 50px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: none;\n'], ['\n  display: none;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _plus = require('../../icons/plus');

var _plus2 = _interopRequireDefault(_plus);

var _styles = require('../styles');

var _colors = require('../../../constants/colors');

var _sizes = require('../../../constants/sizes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var UploadButtonComponent = _styledComponents2.default.label(_templateObject, _styles.PrimaryButtonStyles);

var Text = _styledComponents2.default.span(_templateObject2);

var FileInput = _styledComponents2.default.input(_templateObject3);

var UploadButton = function (_React$Component) {
	_inherits(UploadButton, _React$Component);

	function UploadButton() {
		_classCallCheck(this, UploadButton);

		return _possibleConstructorReturn(this, (UploadButton.__proto__ || Object.getPrototypeOf(UploadButton)).apply(this, arguments));
	}

	_createClass(UploadButton, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				UploadButtonComponent,
				{ disabled: this.props.disabled },
				_react2.default.createElement(
					Text,
					null,
					this.props.text
				),
				_react2.default.createElement(_plus2.default, { primary: _colors.Colors.LightMode, size: _sizes.Sizes.sm }),
				_react2.default.createElement(FileInput, { id: 'file-upload', type: 'file', multiple: false, accept: 'application/' + (this.props.accept || 'pdf'), onChange: this.props.changeEvent })
			);
		}
	}]);

	return UploadButton;
}(_react2.default.Component);

exports.default = UploadButton;